import { render, staticRenderFns } from "./BindsTableHead.vue?vue&type=template&id=02acd604&"
import script from "./BindsTableHead.vue?vue&type=script&lang=js&"
export * from "./BindsTableHead.vue?vue&type=script&lang=js&"
import style0 from "./BindsTableHead.vue?vue&type=style&index=0&id=02acd604&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports